import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function Roadmap() {
  const [phases, setPhases] = useState([]);
  useEffect(() => {
    api.get("/roadmap").then((r) => setPhases(r.data.roadmap)).catch(() => {});
  }, []);

  return (
    <section id="roadmap" className="border-t border-[#3a3a3a]" data-testid="section-roadmap">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 md:py-28">
        <div className="grid grid-cols-12 gap-6 mb-12">
          <div className="col-span-12 lg:col-span-8">
            <div className="font-mono text-[11px] tracking-[0.3em] uppercase text-[#cfff04] mb-3">
              06 // Roadmap
            </div>
            <h2 className="font-display font-black text-3xl sm:text-4xl lg:text-5xl uppercase tracking-tighter">
              From mint to <span className="text-[#cfff04]">mainstream.</span>
            </h2>
          </div>
        </div>

        <div className="relative grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
          {phases.map((p, i) => {
            const active = p.status === "active";
            return (
              <div
                key={p.phase}
                className={`relative min-w-0 border bg-[#121212] p-6 ${
                  active ? "border-[#cfff04]" : "border-[#3a3a3a]"
                }`}
                data-testid={`roadmap-${i}`}
              >
                <div className="flex items-center gap-2 mb-4">
                  <span
                    className={`w-2 h-2 ${
                      active ? "bg-[#cfff04] live-dot" : "bg-[#333]"
                    }`}
                  />
                  <span className="font-mono text-[11px] uppercase tracking-widest text-[#d0d0d0]">
                    {p.phase}
                  </span>
                </div>
                <div className="font-display text-2xl font-black uppercase mb-1 break-words">{p.title}</div>
                <div
                  className={`font-mono text-[11px] uppercase tracking-widest mb-5 ${
                    active ? "text-[#cfff04]" : "text-[#d0d0d0]"
                  }`}
                >
                  {active ? "// In progress" : "// Planned"}
                </div>
                <ul className="space-y-2">
                  {p.items.map((it) => (
                    <li key={it} className="text-sm text-[#e2e2e2] flex gap-2">
                      <span className="text-[#d0d0d0] font-mono">▸</span>
                      {it}
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
